import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-register-pass-key-prompt',
  templateUrl: './register-pass-key-prompt.component.html',
  styleUrl: './register-pass-key-prompt.component.scss',
  standalone: false
})
export class RegisterPassKeyPromptComponent implements OnInit {

  onCreatePasskeySubmit: () => void;
  onPasskeySkipSubmit: () => void;
  onPasskeyDeclineSubmit: () => void;
  client;
  createPasskey;

  constructor(private readonly translate: TranslateService,
    private readonly cookieService: CookieService
  ){}

  ngOnInit(): void {
    this.client  = this.cookieService.get('client');

    if (this.client === 'shaw'){
      this.createPasskey = 'passkey.shaw.createPasskey'
    }
    else if (this.client === 'shaw_direct'){
      this.createPasskey = 'passkey.shawDirect.createPasskey'
    }
    else if (this.client === 'shaw_enterprise'){
      this.createPasskey = 'passkey.shawEnterprise.createPasskey'
    }
    else{
      this.createPasskey = 'passkey.register.createPasskey'
    }
  }


  onCreatePasskeyClick(){
    this.onCreatePasskeySubmit();
  }

  onSkipPasskeyClick(){
    this.onPasskeySkipSubmit();
  }

  onPasskeyDeclineClick(){
    this.onPasskeyDeclineSubmit();
  }
}
